var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpgradeBg = function SvgUpgradeBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.184 10.254.95-2.194c-.357-.713-.711-1.43-1.063-2.151-.222-.454.203-.963.613-.733.652.364 1.306.726 1.962 1.088l1.903-1.187c.398-.248.848.236.65.697-.313.734-.627 1.466-.94 2.196.36.711.724 1.418 1.09 2.12.23.443-.188.934-.607.714-.665-.35-1.328-.702-1.99-1.055l-1.91 1.183c-.402.248-.857-.219-.658-.678Z",
    fill: "url(#upgrade-bg_svg__a)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m155.184 9.254.95-2.194c-.357-.713-.711-1.43-1.063-2.151-.222-.454.203-.963.613-.733.652.364 1.306.726 1.962 1.088l1.903-1.187c.398-.248.848.236.651.697l-.941 2.196c.361.711.724 1.418 1.09 2.12.231.443-.188.934-.607.714a540.59 540.59 0 0 1-1.99-1.055l-1.91 1.183c-.402.248-.857-.219-.658-.678Z",
    fill: "url(#upgrade-bg_svg__b)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.094 5.532C75.31 4.825 75.79 4.307 76.35.095c.707 4.21 1.226 4.69 5.442 5.248-4.214.707-4.695 1.225-5.254 5.437-.686-4.19-1.206-4.69-5.443-5.248ZM185.193 12.41c4.269.191 4.848-.215 6.275-4.217-.189 4.265.218 4.843 4.225 6.27-4.269-.19-4.848.216-6.275 4.218.205-4.24-.198-4.839-4.225-6.27Z",
    fill: "#26272A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M205.743 24.278c1.254-.447 2.651.314 3.08 1.785.429 1.47-.303 2.99-1.557 3.438-1.254.447-2.651-.314-3.08-1.785-.428-1.47.304-2.99 1.557-3.438Z",
    fill: "#F3C12F",
    stroke: "#F3C12F",
    strokeWidth: 0.696
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M7.067 39.23c-.378 1.908-2.064 3.072-3.731 2.658-1.667-.413-2.758-2.267-2.38-4.176.377-1.91 2.063-3.073 3.73-2.66 1.668.415 2.758 2.268 2.38 4.177Z",
    fill: "#F3C12F",
    stroke: "#F3C12F",
    strokeWidth: 0.481
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M225.373 5.643c.624-.223 1.321.156 1.535.89.214.733-.151 1.491-.776 1.714-.625.223-1.321-.156-1.535-.89-.214-.734.151-1.492.776-1.715Z",
    fill: "#F3C12F",
    stroke: "#F3C12F",
    strokeWidth: 0.355
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upgrade-bg_svg__a",
    x1: 3.765,
    y1: 10.963,
    x2: 3.66,
    y2: 5.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upgrade-bg_svg__b",
    x1: 157.765,
    y1: 9.963,
    x2: 157.66,
    y2: 4.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9329"
  })))));
};
export default SvgUpgradeBg;